import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { PLANS, brl } from "@/lib/api";
import { OrderForm } from "./OrderForm";
import { PixStep } from "./PixStep";
import { PaidStep } from "./PaidStep";

export const CheckoutDialog = ({ open, onOpenChange, planId }) => {
  const [order, setOrder] = useState(null);
  const [plan, setPlan] = useState(planId || "1-pergunta");

  useEffect(() => { if (open) setPlan(planId || "1-pergunta"); }, [open, planId]);
  useEffect(() => { if (!open && order?.status === "approved") setOrder(null); }, [open, order]);

  const current = PLANS.find((p) => p.id === plan);
  const step = !order ? "form" : order.status === "approved" ? "paid" : "pix";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-lenis-prevent data-testid="checkout-dialog"
        className="max-h-[92vh] w-[calc(100vw-1.5rem)] max-w-xl overflow-y-auto rounded-2xl border border-[#CBA365]/30 bg-[#0d0519] p-0 text-[#F5F2EB] sm:rounded-2xl">
        <div className="border-b border-white/10 px-6 py-5 md:px-8">
          <p className="text-xs uppercase tracking-[0.3em] text-[var(--gold)]">
            {step === "form" ? "Sua leitura" : step === "pix" ? "Pagamento Pix" : "Confirmado"}
          </p>
          <DialogTitle className="font-display mt-2 text-3xl font-medium">
            {current?.label} <span className="gold-text">· {brl(order?.amount ?? current?.price)}</span>
          </DialogTitle>
          <DialogDescription className="sr-only">Checkout da leitura de tarot</DialogDescription>
        </div>
        <div className="px-6 py-6 md:px-8">
          {step === "form" && <OrderForm plan={plan} setPlan={setPlan} onCreated={setOrder} />}
          {step === "pix" && <PixStep order={order} onUpdate={setOrder} onCancel={() => setOrder(null)} />}
          {step === "paid" && <PaidStep order={order} />}
        </div>
      </DialogContent>
    </Dialog>
  );
};
